import { useTheme } from "@mui/material";
import { match } from "ts-pattern";

/** How far something has got, as a mark: done, begun, or not begun. */
export type ProgressMarkKind = "done" | "begun" | "not_begun";

/**
 * A filled tick, a half-filled circle or an empty one. Hidden from assistive
 * technology, so a caller must say the same in text beside it.
 */
export const ProgressMark = ({
  kind,
  size = 18,
}: {
  kind: ProgressMarkKind;
  size?: number;
}) => {
  const { palette } = useTheme();
  const filled = palette.primary.main;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      aria-hidden="true"
      style={{ flex: "none" }}
    >
      {match(kind)
        .with("done", () => (
          <>
            <circle cx="9" cy="9" r="8" fill={filled} />
            <path
              d="M5.5 9.2l2.3 2.3 4.7-4.9"
              fill="none"
              stroke={palette.primary.contrastText}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        ))
        .with("begun", () => (
          <>
            <circle
              cx="9"
              cy="9"
              r="7.25"
              fill="none"
              stroke={filled}
              strokeWidth="1.5"
            />
            <path d="M9 1.75A7.25 7.25 0 0 1 9 16.25Z" fill={filled} />
          </>
        ))
        .with("not_begun", () => (
          <circle
            cx="9"
            cy="9"
            r="7.25"
            fill="none"
            stroke={palette.grey[500]}
            strokeWidth="1.5"
          />
        ))
        .exhaustive()}
    </svg>
  );
};
